import { BaseError } from '@dynamic-labs-sdk/client';

export class NotSolanaProviderError extends BaseError {
  public readonly providerKey: string;

  constructor(params: { providerKey: string }) {
    super({
      cause: null,
      code: 'not_solana_provider_error',
      docsUrl: null,
      name: 'NotSolanaProviderError',
      shortMessage: 'Provider is not a Solana wallet provider',
    });

    this.providerKey = params.providerKey;
  }
}
